<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()"><mat-icon>close</mat-icon></button>
<h1 mat-dialog-title>
    Advanced Filter
</h1>
<div mat-dialog-content>

    <div class="pt-2">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>Fundamentals</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">Current EPS</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">Price to book</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>Technicals</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">Momentum</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">RSI</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>Management</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">% Women on board</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <mat-checkbox color="primary">PE ownership</mat-checkbox>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <span>Range: </span>
                        <mat-slider
                                [max]="100"
                                [min]="0"
                                [step]="1"
                                [discrete]="true"
                                [showTickMarks]="true"
                                color="primary"
                                class="w-100"
                        >
                        </mat-slider>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="mt-4">
        <button mat-stroked-button  color="primary" (click)="accordion.openAll()">Show All</button>
        <button mat-stroked-button  color="primary" class="ms-2" (click)="accordion.closeAll()">Hide All</button>

        <button mat-flat-button class="float-end" color="primary" (click)="onNoClick()">Apply</button>
        <button mat-flat-button class="float-end mr-2" >Clear All</button>
    </div>

</div>
